import { useState } from 'react';
import {
  Modal,
  ModalHeader,
  ModalBody,
  ModalFooter,
  Button,
  Alert,
  FormGroup,
  Label,
  Input,
} from 'reactstrap';

/**
 * Confirm-Dialog für irreversible Aktionen (z. B. DSGVO-Anonymisierung).
 *
 * Operator muss den Pflicht-String exakt tippen → Confirm-Button aktiviert.
 * Zusätzliche Felder (`extraFields`-Render-Prop) werden als Payload zurück
 * an `onConfirm({ ...extras, confirmation })` gereicht.
 *
 * Spec-Quelle: user-crud-admin.md → Anonymize-Modal.
 */
export function ConfirmStringDialog({
  isOpen,
  title,
  body,
  requiredString,
  busy = false,
  onConfirm,
  onCancel,
  /** Optional: `(values, setValues) => ReactNode` */
  renderExtraFields,
  /** Optional: Default-Werte für die extra-Felder */
  initialExtras = {},
}) {
  const [typed, setTyped] = useState('');
  const [extras, setExtras] = useState(initialExtras);

  const ok = typed === requiredString;
  const close = () => {
    if (busy) return;
    setTyped('');
    setExtras(initialExtras);
    onCancel();
  };

  const submit = () => {
    if (!ok) return;
    onConfirm({ ...extras, confirmation: requiredString });
  };

  return (
    <Modal isOpen={isOpen} toggle={close} backdrop={busy ? 'static' : true}>
      <ModalHeader toggle={busy ? undefined : close}>{title}</ModalHeader>
      <ModalBody>
        <Alert color="danger" className="small">
          {body}
        </Alert>

        {renderExtraFields && renderExtraFields(extras, setExtras)}

        <FormGroup className="mt-3">
          <Label for="confirmString" className="small fw-semibold">
            Bestätigung — tippe exakt: <code>{requiredString}</code>
          </Label>
          <Input
            id="confirmString"
            value={typed}
            onChange={(e) => setTyped(e.target.value)}
            placeholder={requiredString}
            spellCheck={false}
            autoComplete="off"
            style={{ fontFamily: 'ui-monospace, monospace' }}
          />
        </FormGroup>
      </ModalBody>
      <ModalFooter>
        <Button color="secondary" outline onClick={close} disabled={busy}>
          Abbrechen
        </Button>
        <Button color="danger" onClick={submit} disabled={!ok || busy}>
          {busy ? 'Bitte warten…' : 'Endgültig ausführen'}
        </Button>
      </ModalFooter>
    </Modal>
  );
}
